/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Update_FailedInputs */

const en_admin_external_booking_edit_update_failed = /** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update booking. Please try again.`)
};

const de_admin_external_booking_edit_update_failed = /** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung konnte nicht aktualisiert werden. Bitte versuche es erneut.`)
};

const es_admin_external_booking_edit_update_failed = /** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar la reserva. Inténtalo de nuevo.`)
};

const fr_admin_external_booking_edit_update_failed = /** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la mise à jour de la réservation. Veuillez réessayer.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */
const it_admin_external_booking_edit_update_failed = en_admin_external_booking_edit_update_failed;

/** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_update_failed = en_admin_external_booking_edit_update_failed;

/** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */
const pl_admin_external_booking_edit_update_failed = en_admin_external_booking_edit_update_failed;

/** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */
const hu_admin_external_booking_edit_update_failed = en_admin_external_booking_edit_update_failed;

/** @type {(inputs: Admin_External_Booking_Edit_Update_FailedInputs) => LocalizedString} */
const ro_admin_external_booking_edit_update_failed = en_admin_external_booking_edit_update_failed;

/**
* | output |
* | --- |
* | "Failed to update booking. Please try again." |
*
* @param {Admin_External_Booking_Edit_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_update_failed = /** @type {((inputs?: Admin_External_Booking_Edit_Update_FailedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Update_FailedInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_update_failed(inputs)
	if (locale === "de") return de_admin_external_booking_edit_update_failed(inputs)
	if (locale === "es") return es_admin_external_booking_edit_update_failed(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_update_failed(inputs)
	if (locale === "it") return it_admin_external_booking_edit_update_failed(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_update_failed(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_update_failed(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_update_failed(inputs)
	return ro_admin_external_booking_edit_update_failed(inputs)
});
export { admin_external_booking_edit_update_failed as "admin.external_booking_edit.update_failed" }